import React from 'react'
import { useSelector } from 'react-redux'

import { Features } from '@app/Feature'
import { isFeatureEnabled } from '@app/Feature/Store/selectors'
import { CustomerDocument } from '@app/graphql/types'
import { UtilityBillAICheckResults } from '@app/modules/Messages/Components/UtilityBillAICheckResults/UtilityBillAICheckResults'

export const UtilityBillAIContainer = ({ documents = [] }: { documents: CustomerDocument[] }) => {
  const utilityBillAICheckEnabled = useSelector(
    isFeatureEnabled(Features.UTILITY_BILL_AI_CHECK_IN_CHAT)
  )

  const latestUtilityBill = documents
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .find((document) => document?.category?.name === 'Nebenkostenabrechnung')

  if (!utilityBillAICheckEnabled || !latestUtilityBill) {
    return null
  }

  return (
    <UtilityBillAICheckResults
      documentId={latestUtilityBill.id}
      documentName={latestUtilityBill.name}
    />
  )
}
